import React, {Component} from 'react';
import {IProps, IState} from "./types";
import {connect} from "react-redux";
import {REDUCER_TYPE} from "../../modules/Reducer";
import {withTranslation} from "react-i18next";
import {JitsiMeeting} from "@jitsi/react-sdk";
import i18n from "i18next";
import IJitsiMeetExternalApi from "@jitsi/react-sdk/lib/types/IJitsiMeetExternalApi";
import {CallReview} from "../../components/CallReview";
import {JitsiJoined} from "../../modules/Actions";

class JitsiVideo extends Component <IProps, IState> {
    private videoIframe: HTMLIFrameElement | null = null;
    private externalApi: IJitsiMeetExternalApi | null = null;
    constructor(props: IProps) {
        super(props);
        this.state = {
            isActiveTab: props.isActiveTab,
            lang: i18n.language,
            needReview: false
        };

        this.toggleIframeVisibility = this.toggleIframeVisibility.bind(this);
    }

    toggleIframeVisibility() {
        this.setState((prevState) => ({
            isActiveTab: !prevState.isActiveTab,
        }));
    }

    componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.state.isActiveTab !== this.props.isActiveTab && this.videoIframe) {
            this.setState(
                {isActiveTab: this.props.isActiveTab}, () => {
                    if (this.videoIframe) {
                    this.videoIframe.style.display = this.state.isActiveTab ? 'block' : 'none';
                    }
            }
            );
        }
    }

    componentWillUnmount() {
        if (this.props.dispatch) {
            this.props.dispatch(JitsiJoined(false));
        }
    }

    render() {
        if (this.props.jitsiData === null && typeof this.props.jitsiData !== "undefined") {
            return <div></div>;
        }

        return <div id={'videoMeeting'} className={'video'} style={(!this.state.isActiveTab ? {display: "none"} : {})}>
            {this.state.needReview && <div className={'video-review'}>
                <CallReview
                    callId={this.props.callId}
                    token={this.props.jwtToken ? this.props.jwtToken : ''}
                    room={this.props.room?.uuid ? this.props.room?.uuid : ''}
                    participant={this.props.authUser?.uuid ? this.props.authUser.uuid : ''}
                    issues={this.props.reviewIssues}
                    dismiss={() => {
                        this.setState({needReview: false})
                    }}
                    domain={this.props.jitsiData.domain}
                />
            </div>}
            <div className={'video-client'} style={(this.state.needReview ? {display: "none"} : {})}>
                <JitsiMeeting
                    domain={this.props.jitsiData.domain}
                    jwt={this.props.jitsiData.jwt}
                    roomName={this.props.jitsiData.room}
                    configOverwrite = {{
                        startWithAudioMuted: false,
                        disableModeratorIndicator: true,
                        startScreenSharing: false,
                        enableEmailInStats: false,
                        enableClosePage: true
                    }}
                    interfaceConfigOverwrite = {{
                        APP_NAME: 'Halodoctor',
                        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                        GENERATE_ROOMNAMES_ON_WELCOME_PAGE: false,
                        HIDE_INVITE_MORE_HEADER: true,
                    }}
                    onApiReady = { (externalApi) => {
                        this.externalApi = externalApi;

                        if (this.props.dispatch) {
                            // nasłuchuj wejścia / wyjścia z konferencji
                            if (externalApi.addEventListeners) {
                                externalApi.addEventListeners({
                                    videoConferenceJoined: () => {
                                        this.props.dispatch && this.props.dispatch(JitsiJoined(true));
                                    },
                                    videoConferenceLeft: () => {
                                        window.dispatchEvent(new CustomEvent('jitsi.disconnecting'));
                                     //   this.props.dispatch && this.props.dispatch(JitsiJoined(false));
                                    }
                                });
                            } else if ((externalApi as any).on) {
                                (externalApi as any).on('videoConferenceJoined', () => {
                                    this.props.dispatch && this.props.dispatch(JitsiJoined(true));
                                });
                                (externalApi as any).on('videoConferenceLeft', () => {
                                    window.dispatchEvent(new CustomEvent('jitsi.disconnecting'));
                                   // this.props.dispatch && this.props.dispatch(JitsiJoined(false));
                                });
                            }
                        }
                    }}
                    onReadyToClose={() => {
                        window.dispatchEvent(new CustomEvent('jitsi.disconnecting'));
                        if (this.props.dispatch) {
                            //this.props.dispatch(JitsiJoined(false));
                        }

                        this.setState({
                            needReview:true
                        })

                        setTimeout(() => {
                            if (this.videoIframe) {
                                this.videoIframe.src = this.videoIframe.dataset.initSrc ? this.videoIframe.dataset.initSrc.toString() : '';
                            }
                        }, 4500)
                    }}
                    getIFrameRef={(iframeRef) => {
                        iframeRef.dataset.initSrc = iframeRef.dataset.src;
                        iframeRef.style.height = '100%';
                        iframeRef.style.width = '100%';
                        iframeRef.style.position = 'absolute !important';
                        this.videoIframe = iframeRef.getElementsByTagName('iframe')[0];
                        if (this.videoIframe) {
                            this.videoIframe.style.position = 'absolute';
                            this.videoIframe.style.display = this.state.isActiveTab ? 'block' : 'none';
                            this.videoIframe.dataset.initSrc = this.videoIframe.src
                        }
                    }}
                    lang={i18n.language}
                />
            </div>
        </div>;

    }
}

const mapStateToProps = (state: REDUCER_TYPE) => {
    return state
}

// @ts-ignore
export default withTranslation()(connect(mapStateToProps)(JitsiVideo));
